import { render, staticRenderFns } from "./typeform.vue?vue&type=template&id=f7fdec7c&scoped=true&"
import script from "./typeform.vue?vue&type=script&lang=js&"
export * from "./typeform.vue?vue&type=script&lang=js&"
import style0 from "./typeform.vue?vue&type=style&index=0&id=f7fdec7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fdec7c",
  null
  
)

export default component.exports